__turbopack_context__.v({
  "app-container": "dYWVHq_app-container",
  "button": "dYWVHq_button",
  "cards-list-item": "dYWVHq_cards-list-item",
  "cards-list-item-eyebrow": "dYWVHq_cards-list-item-eyebrow",
  "cards-list-item-icons": "dYWVHq_cards-list-item-icons",
  "cards-list-item-image": "dYWVHq_cards-list-item-image",
  "cards-title-eyebrow": "dYWVHq_cards-title-eyebrow",
});
